import React, { useContext, useEffect, useState } from "react";
import { Button } from "../../../controls";
import { action, API, controller } from "../../../api/api";
import { RmvEmptyProp, ToFormData } from "../../../hooks/Method";
import { AppContext } from "../../../App";
import { Snackbar } from "../../../layout";
import { format, formatDistanceToNow } from "date-fns";

const UserCheckInOut = ({ open }) => {
  const { authUser } = useContext(AppContext);
  const [userCheckInOut, setUserCheckInOut] = useState({});
  const [snackbar, setSnackbar] = useState({
    show: false,
    type: "error",
    msg: "",
  });

  useEffect(() => {
    if (authUser && authUser.id && open) {
      API(controller.UserCheckInOut + action.GetByAuthUser).get((res) => {
        if (res && res.status === 200 && res.result && res.result.id) {
          setUserCheckInOut({ ...res.result });
        }
      });
    }
    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser, open]);

  const handleCheckIn = () => {
    API(controller.UserCheckInOut + action.Post).post(
      ToFormData({
        checkIn: new Date().toLocaleString(),
        userId: authUser.id,
        orgId: authUser.orgId,
      }),
      (res) => {
        if (res && res.status === 201) {
          setUserCheckInOut({ ...res.result });
          setSnackbar({
            show: true,
            type: "success",
            msg: res.msg,
          });
        }
      }
    );
  };

  const handleCheckOut = () => {
    API(controller.UserCheckInOut + action.Put).put(
      ToFormData(
        RmvEmptyProp({
          ...userCheckInOut,
          checkOut: new Date().toLocaleString(),
        })
      ),
      (res) => {
        if (res && res.status === 200) {
          setUserCheckInOut({});
          setSnackbar({
            show: true,
            type: "success",
            msg: res.msg,
          });
        }
      }
    );
  };

  return (
    <>
      {userCheckInOut.id ? (
        <div className="grid p-[20px] border-b gap-2">
          <span className="text-[14px] font-medium text-gray-500 uppercase">
            You are clocked in
          </span>
          <span className="text-[20px] font-bold text-gray-600">
            {formatDistanceToNow(new Date(userCheckInOut.checkIn), {
              addSuffix: true,
            })}
          </span>
          <span className="text-[12px] font-medium text-gray-500">
            You clocked in at{" "}
            {userCheckInOut.id &&
              format(new Date(userCheckInOut.checkIn), "MMM dd, yyyy, h:mm a")}
          </span>
          <div className="mt-[20px]">
            <Button onClick={handleCheckOut} size="large">
              Check out
            </Button>
          </div>
        </div>
      ) : (
        <div className="grid p-[20px] border-b gap-2">
          <span className="text-[14px] font-medium text-gray-500 uppercase">
            You are clocked out
          </span>
          <span className="text-[26px] font-bold text-gray-400">
            0hrs, 0min
          </span>

          <div className="mt-[20px]">
            <Button onClick={handleCheckIn} size="large" color="success">
              Check in
            </Button>
          </div>
        </div>
      )}
      {snackbar && (
        <Snackbar
          autoHideDuration={2000}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
          vertical="bottom"
          horizontal="left"
        />
      )}
    </>
  );
};

export default UserCheckInOut;
